// extracted by mini-css-extract-plugin
export default {"tooltip":"RN-z","arrow":"SN-z"};